// KTV Health Food — Factory Locator data.
// Add more categories or locations here; the UI renders everything automatically.

export const LOCATOR_INSTRUCTIONS = [
  "Read the first two letters inside the bracket of your batch number — you'll find the batch code printed just below the MRP on the side of your pack.",
  "Match those two letters against the list below to find the manufacturing plant address and its FSSAI License Number.",
];

export const CATEGORIES = [
  {
    name: "Oils",
    tag: "Cold-pressed & refined",
    locations: [
      {
        code: "CI",
        place: "Kodungaiyur",
        name: "K.T.V. Health Food Private Limited",
        address:
          "7/3, Arul Nagar Salai, R.V. Nagar Post, Kodungaiyur, Chennai District, Tamil Nadu – 600118",
        fssai: "10012042000120",
      },
      {
        code: "GI",
        place: "Gummidipoondi",
        name: "K.T.V. Health Food Private Limited",
        address:
          "B-69, SIPCOT Industrial Complex, Gummidipoondi, Thiruvallur District, Tamil Nadu – 601201",
        fssai: "10012042000119",
      },
      {
        code: "TN",
        place: "Tuticorin",
        name: "K.T.V. Health Food Private Limited",
        address:
          "Plot No. C-68, 85 & 88, 2nd Main Road, SIPCOT Industrial Complex, Madathur Post, Tuticorin District, Tamil Nadu – 628008",
        fssai: "10012042000360",
      },
    ],
  },
  {
    name: "Edible Free Flow Salt",
    tag: "Iodised & free-flowing",
    locations: [
      {
        code: "TT",
        place: "Tuticorin",
        name: "SWAMY TRADES & ENTERPRISES Pvt. Ltd.",
        address:
          "653/1, Tiruchendur Road, Mullakkadu, Tuticorin – 628005, Tamil Nadu",
        fssai: "10016042002484",
      },
      {
        code: "AE",
        place: "Thoothukudi",
        name: "S.K.S.C. NADARAJAN & BROS.",
        address: "117, South Raja Street, Thoothukudi – 628001, Tamil Nadu",
        fssai: "10014042001615",
      },
      {
        code: "TS",
        place: "Thoothukudi",
        name: "Sahayamatha Salterns Pvt. Ltd.",
        address:
          "Survey No. 1 & 2 / 3, Pattanamarudur Village, Ottaipidaram (Taluk), Thoothukudi, Tamil Nadu – 628903",
        fssai: "10015042002067",
      },
      {
        code: "TM",
        place: "Thoothukudi",
        name: "Maheswari Salt Trading Co.",
        address:
          "C-65, 66 SIPCOT Industrial Complex, Thoothukudi, Tamil Nadu – 628008",
        fssai: "10012042000657",
      },
      {
        code: "TR",
        place: "Thoothukudi",
        name: "Sahayamatha Salt Refinery Pvt. Ltd.",
        address:
          "Survey No. 33/1,3,6, 33/1,2 & 34/5, Kalloorani Village, Sippikulam Post, Vilathikulam (Taluk), Thoothukudi, Tamil Nadu – 628903",
        fssai: "10013042001284",
      },
    ],
  },
  {
    name: "Edible Crystal Salt",
    tag: "Sun-dried crystals",
    locations: [
      {
        code: "TA",
        place: "Tuticorin",
        name: "SRI ALAGAR SALT",
        address:
          "4/298, Tiruchendur Road, Mullakkadu, Tuticorin – 628005, Tamil Nadu",
        fssai: "10021042000260",
      },
      {
        code: "TS",
        place: "Thoothukudi",
        name: "Sahayamatha Salterns Pvt. Ltd.",
        address:
          "Survey No. 1 & 2 / 3, Pattanamarudur Village, Ottaipidaram (Taluk), Thoothukudi, Tamil Nadu – 628903",
        fssai: "10015042002067",
      },
    ],
  },
];
